import { MutationTree } from "vuex";
import { ScheduleMeeting } from "./types";

export const mutations: MutationTree<ScheduleMeeting> = {
  SET_IS_MODAL_OPEN(state, isModalOpened: boolean) {
    state.isModalOpened = isModalOpened;
  },
};
